
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class EstensioniDialog extends Serenity.EntityDialog<EstensioniRow, any> {
        protected getFormKey() { return EstensioniForm.formKey; }
        protected getIdProperty() { return EstensioniRow.idProperty; }
        protected getLocalTextPrefix() { return EstensioniRow.localTextPrefix; }
        protected getNameProperty() { return EstensioniRow.nameProperty; }
        protected getService() { return EstensioniService.baseUrl; }
        protected getDeletePermission() { return EstensioniRow.deletePermission; }
        protected getInsertPermission() { return EstensioniRow.insertPermission; }
        protected getUpdatePermission() { return EstensioniRow.updatePermission; }

        protected form = new EstensioniForm(this.idPrefix);

    }
}